import _ from 'lodash'
import axios from 'axios'

import { encodeForHeader } from './encodeForHeader'

/* eslint-disable max-params */
export function uploadFile(
    file,
    url,
    progressPercent = _.noop,
    withAttachmentHeader = false,
    contentType = null,
) {
    let headers = {
        'Content-Type':
            contentType === null || contentType === undefined
                ? file.type
                : contentType,
    }

    if (withAttachmentHeader) {
        headers = {
            ...headers,
            'Content-Disposition': `attachment; filename*=UTF-8''${encodeForHeader(
                file.name,
            )}`,
        }
    }

    return axios.put(url, file, {
        headers,
        onUploadProgress: evt => {
            if (evt.lengthComputable) {
                const percent = evt.loaded / evt.total

                evt.percent = percent
            }
            return progressPercent(evt)
        },
        withCredentials: false,
    })
}
/* eslint-disable max-params */

export function uploadAttachmentFile(file, url, progressPercent = _.noop) {
    return uploadFile(file, url, progressPercent, true)
}

export function uploadItem(
    file,
    { onProgress = _.noop, onSuccess = _.noop, onError = _.noop },
) {
    if (file.uploadUrl == null) {
        // @Note: This needs to be deferred so that the uploader knows to display the error styling
        //        due to the internal state not updating until the next event loop
        return _.defer(() => onError(new Error('Missing upload url')))
    }

    return uploadAttachmentFile(file, file.uploadUrl, onProgress)
        .then(onSuccess)
        .catch(onError)
}
